import React, { createContext, useContext, useState, ReactNode } from 'react';

interface EditingStateContextType {
  isEditing: boolean;
  setIsEditing: (editing: boolean) => void;
}

const EditingStateContext = createContext<EditingStateContextType | undefined>(undefined);

export const useEditingState = () => {
  const context = useContext(EditingStateContext);
  if (context === undefined) {
    throw new Error('useEditingState must be used within an EditingStateProvider');
  }
  return context;
};

interface EditingStateProviderProps {
  children: ReactNode;
}

export const EditingStateProvider: React.FC<EditingStateProviderProps> = ({ children }) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <EditingStateContext.Provider value={{ isEditing, setIsEditing }}>
      {children}
    </EditingStateContext.Provider>
  );
};